import { Card, Flex, Skeleton } from '@blockanalitica/ui';
import { ReactNode } from 'react';

export default function AsyncHomeCard({
  title,
  error,
  isLoading,
  children
}: {
  title: ReactNode;
  error: Error | boolean | undefined;
  isLoading: boolean;
  children: ReactNode;
}) {
  if (isLoading) {
    return (
      <Card variant="homeCard" flex="1">
        <Flex alignItems="center" gap="2xs" padding="s">
          <Skeleton height="1" width="100%" />
        </Flex>
        <Card variant="homeCardInset" gap="s" justifyContent="space-between">
          <Skeleton height="344px" width="100%" />
        </Card>
      </Card>
    );
  }
  if (error) {
    return null;
  }

  return (
    <Card variant="homeCard" flex="1">
      <Flex alignItems="center" gap="2xs" padding="s">
        {title}
      </Flex>
      <Card variant="homeCardInset" gap="s" justifyContent="space-between">
        {children}
      </Card>
    </Card>
  );
}
